import * as React from "react";
import CustomDialog, { RenderProps } from "components/Dialog/CustomDialog";
import { useProjectContext } from "areas/projects/context";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import { ProjectRouteParams } from "../../ProjectsRoutes/ProjectRouteParams";
import { DeploymentProcessResource } from "client/resources";
import DialogTrigger from "components/Dialog/DialogTrigger";
import { useProcessContext } from "../Contexts/ProcessContext";
import OclEditorDialogLayout from "../OclEditorDialogLayout/OclEditorDialogLayout";

interface DeploymentProcessOclEditorDialogTriggerProps {
    resource: DeploymentProcessResource;
}

const DeploymentProcessOclEditorDialogTrigger: React.FC<DeploymentProcessOclEditorDialogTriggerProps> = ({ resource: deploymentProcess }) => {
    const projectContext = useProjectContext();
    const processContext = useProcessContext();
    const { projectContextRepository } = projectContext.state;
    const history = useHistory();
    const location = useLocation();
    const match = useRouteMatch<ProjectRouteParams>();
    return (
        <DialogTrigger
            render={(renderProps) => {
                renderProps.openDialog();
                return (
                    <CustomDialog
                        open={renderProps.open}
                        close={renderProps.closeDialog}
                        render={(dialogProps: RenderProps) => (
                            <OclEditorDialogLayout
                                {...dialogProps}
                                getOcl={async () => {
                                    const oclResource = await projectContextRepository.DeploymentProcesses.getOcl(deploymentProcess);
                                    return oclResource.Ocl;
                                }}
                                modifyOcl={async (ocl: string) => {
                                    const oclResource = await projectContextRepository.DeploymentProcesses.modifyOcl(deploymentProcess, { Ocl: ocl });
                                    return oclResource.Ocl;
                                }}
                                resource={deploymentProcess}
                                onSave={async () => {
                                    await processContext.actions.refreshFromServer();
                                    renderProps.closeDialog();
                                }}
                                onClose={() => {
                                    renderProps.closeDialog();
                                }}
                                history={history}
                                location={location}
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                match={match!}
                            />
                        )}
                    />
                );
            }}
        />
    );
};

export default DeploymentProcessOclEditorDialogTrigger;
